import { Field } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import { SHOP_CURRENCY } from '../../main/shops/constants';

export const CurrencySelect = ({ name, disabled }) => (
  <Field component="select" name={name} className="c-select" disabled={disabled}>
    <option value={SHOP_CURRENCY.usd}>{SHOP_CURRENCY.usd.toUpperCase()}</option>
    <option value={SHOP_CURRENCY.cad}>{SHOP_CURRENCY.cad.toUpperCase()}</option>
    <option value={SHOP_CURRENCY.gbp}>{SHOP_CURRENCY.gbp.toUpperCase()}</option>
    <option value={SHOP_CURRENCY.aud}>{SHOP_CURRENCY.aud.toUpperCase()}</option>
    <option value={SHOP_CURRENCY.eur}>{SHOP_CURRENCY.eur.toUpperCase()}</option>
  </Field>
);

CurrencySelect.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

CurrencySelect.defaultProps = {
  disabled: false,
};
